/* eslint-disable */

import React from 'react'
import PropTypes from 'prop-types'
import _ from 'lodash'
import classnames from 'classnames'
import { DragSource as dragSource, DropTarget as dropTarget } from 'react-dnd'
import ReactDOM from 'react-dom'

import currency from '../../../lib/currency.jsx'
import DateUtil from '../../../lib/dateutil.jsx'
import IntlUtil from '../../../lib/intlutil.jsx'
import { TIME_RATE_CARD, EXPENSE_RATE_CARD } from '../../../../shared/constants'
import FormRateCardAutoComplete from '../../../common/form/ratecard_auto_complete/ratecard_auto_complete.jsx'
import DateRangePicker from '../../../common/form/daterange_picker/daterange_picker.jsx'
import InputPrice from '../../../common/form/input_price/input_price.jsx'
import InputNumber from '../../../common/form/input_number/input_number.jsx'
import FormVatTypeSelect from '../../../common/form/vat_typeselect/vat_typeselect.jsx'
import PopupBudgetPurchaseorder from '../../popup/popup_budget_purchaseorder/popup_budget_purchaseorder.jsx'
import ConfirmDelete from '../../../common/common/confirm_delete/confirm_delete.jsx'
import IntlMessage from '../../../common/common/intl/intl_message.jsx'
import WysiwygEditor from '../../../common/form/wysiwyg_editor/wysiwyg_editor.jsx'
import Button from '../../../common/common/button/button.jsx'
import EstimateBudgetItemBase from '../estimate_budget_item/estimate_budget_itembase.jsx'
import FormAutoComplete from '../../../common/form/auto_complete/auto_complete.jsx'
import PriceText from '../../../common/common/price_text/price_text.jsx'
import CurrencyIcon from '../../../common/common/currency_icon/currency_icon.jsx'
import ExpensePurchaseOrders from './expense-purchase-orders'
import {
  trackAddExpense,
  trackEditMarkup,
  trackEditSellingPrice,
  trackUnfoldExpenseActivity
} from './utils.js'

const phaseItemSource = {
  beginDrag (props, _monitor) {
    const item = props.item
    item.orgGroupId = item.groupId
    item.orgPhaseId = item.phaseId
    item.orgIndex = props.getItemIndex(item.dragId)

    if (props.onDragStart) {
      props.onDragStart(item)
    }

    return item
  },
  endDrag (props, monitor) {
    const item = monitor.getItem()
    const didDrop = monitor.didDrop()

    if (!didDrop && props.onMoveItem) {
      props.onMoveItem(
        item.phaseId,
        item.groupId,
        item.orgPhaseId,
        item.orgGroupId,
        null,
        item,
        item.orgIndex
      )
    }

    if (props.onDragEnd) {
      props.onDragEnd()
    }
  }
}

const phaseItemTarget = {
  hover (props, monitor, component) {
    const item = monitor.getItem()
    if (item.dragItemType === 'item') {
      const overId = props.item.dragId

      const currentPos = props.getItemPosition(item.dragId)
      const overPos = props.getItemPosition(overId)

      const boundingRect = ReactDOM.findDOMNode(
        component
      ).getBoundingClientRect()
      const clientOffset = monitor.getClientOffset()
      const ownMiddleY = boundingRect.bottom - boundingRect.top
      const offsetY = clientOffset.y - boundingRect.top

      if (currentPos < overPos && offsetY < ownMiddleY - 20) {
        return
      }

      if (currentPos > overPos && offsetY > 20) {
        return
      }

      if (props.onMoveItem && item.dragId !== overId) {
        props.onMoveItem(
          item.phaseId,
          item.groupId,
          props.item.phaseId,
          props.item.groupId,
          overId,
          item,
          null
        )
      }
    }
  }
}

@dropTarget(
  _props => 'all',
  phaseItemTarget,
  (connect, monitor) => ({
    connectDropTarget: connect.dropTarget(),
    isOver: monitor.isOver()
  })
)
@dragSource(
  _props => 'all',
  phaseItemSource,
  (connect, monitor) => ({
    connectDragSource: connect.dragSource(),
    connectDragPreview: connect.dragPreview(),
    isDragging: monitor.isDragging(),
    dragItem: monitor.getItem()
  })
)
class ProjectBudgetItem extends EstimateBudgetItemBase {
  constructor (props) {
    super(props)

    this.data = {
      activityKeyword: props.item && props.item.title ? props.item.title : '',
      menuItems: [
        {
          icon: 'common-menudelete',
          title: 'project.viewBudget.deleteActivity',
          action: 'delete'
        }
      ],
      selectedRateCard: null,
      showExpand: false,
      supplierKeyword: '',
      supllierOptions: []
    }

    this.state = {
      activityTitleErr: false,
      supplierContactName: '',
      newSupplierName: '',
      bHideSupplierAdd: true
    }

    this._references = {
      inputAddSupplier: React.createRef(),
      daterange: React.createRef(),
      refBudgetPurchaseOrder: React.createRef(),
      inputTimeTitle: React.createRef(),
      confirmDelete: React.createRef(),
      triggerPurchaseOrder: React.createRef()
    }

    this._summaryTime = null
  }

  static get propTypes () {
    return {
      item: PropTypes.object,
      rateCards: PropTypes.array,
      onCreateItemSupplier: PropTypes.func,
      estimateRateCards: PropTypes.array,
      onDeleteItemSupplier: PropTypes.func,
      isDragLayer: PropTypes.bool,
      showDate: PropTypes.bool,
      dragItem: PropTypes.object,
      phaseFromDate: PropTypes.any,
      phaseToDate: PropTypes.any,
      projectStartDate: PropTypes.any,
      projectEndDate: PropTypes.any,
      connectDragPreview: PropTypes.func,
      connectDropTarget: PropTypes.func,
      connectDragSource: PropTypes.func,
      onItemCreate: PropTypes.func,
      onItemUpdate: PropTypes.func,
      onUpdateSubtotal: PropTypes.func,
      onUpdateTotal: PropTypes.func,
      onUpdateEditable: PropTypes.func,
      onChange: PropTypes.func,
      onSave: PropTypes.func,
      onRemove: PropTypes.func,
      onSearchSupplier: PropTypes.func,
      isEstimate: PropTypes.bool,
      disabledEdit: PropTypes.bool,
      hideDateRange: PropTypes.bool,
      phaseStatus: PropTypes.string,
      rateMarkup: PropTypes.number,
      onCreatePurchaseOrder: PropTypes.func,
      onViewPurchaseOrder: PropTypes.func,
      onCreateContact: PropTypes.func,
      calculateSpentAmount: PropTypes.func,
      disableDrag: PropTypes.bool,
      onInsertItemInMiddle: PropTypes.func,
      filterType: PropTypes.string,
      calculateMarkupPercentage: PropTypes.func,
      onPoAttachmentDownload: PropTypes.func,
      onAddExpense: PropTypes.func,
      onEditExpense: PropTypes.func
    }
  }

  static get defaultProps () {
    return {
      item: null,
      rateCards: [],
      onCreateItemSupplier: null,
      estimateRateCards: [],
      onDeleteItemSupplier: null,
      isDragLayer: false,
      showDate: false,
      dragItem: null,
      phaseFromDate: null,
      phaseToDate: null,
      projectStartDate: null,
      projectEndDate: null,
      connectDragPreview: null,
      connectDropTarget: null,
      connectDragSource: null,
      onItemCreate: null,
      onItemUpdate: null,
      onUpdateSubtotal: null,
      onUpdateTotal: null,
      onUpdateEditable: null,
      onChange: null,
      onSave: null,
      onRemove: null,
      onSearchSupplier: null,
      isEstimate: false,
      disabledEdit: false,
      hideDateRange: false,
      phaseStatus: '',
      rateMarkup: 0,
      onCreatePurchaseOrder: null,
      onViewPurchaseOrder: null,
      onCreateContact: null,
      calculateSpentAmount: null,
      disableDrag: false,
      onInsertItemInMiddle: null,
      filterType: '',
      calculateMarkupPercentage: null,
      onPoAttachmentDownload: null,
      onAddExpense: null,
      onEditExpense: null
    }
  }

  _onChangeSellingPrice = e => {
    trackEditSellingPrice()
    this._onChangeActivityInput('sellingPrice', e)
  }

  _onChangeMarkupPercentage = e => {
    trackEditMarkup()
    this._onChangeActivityInput('markupPercentage', e)
  }

  /* Render functions */
  render () {
    const {
      dragItem,
      item,
      isDragLayer,
      showDate,
      connectDragPreview,
      connectDropTarget,
      showLabelType
    } = this.props
    const connectDragSource =
      this.props.connectDragSource || this._connectDragSource
    if (!item) return null

    let bShowSupplierAdd = false
    if (
      !this.state.bHideSupplierAdd &&
      this.data.supllierOptions.length === 0
    ) {
      bShowSupplierAdd = true
    }

    const bHasSubCont =
      item.type === 'time-activity' || item.type === 'expense-activity'
    return connectDragPreview(
      connectDropTarget(
        <div
          className={classnames('projectbudgetitem', {
            projectbudgetitem_isdragging:
              !isDragLayer &&
              dragItem &&
              dragItem.dragItemType === 'item' &&
              dragItem.dragId === item.dragId,
            projectbudgetitem_isdraftdrag: !isDragLayer && item.isEmptyDragItem,
            hasdate: showDate,
            dropopen: this.data.showExpand,
            showadd: item.showAdd,
            hasnotitle: !item.bTitleCompleted
          })}
        >
          <span className='itemcontentbg'></span>
          {this._isEditEnabled() &&
            connectDragSource(
              <div className='hovericon'>
                <span className='iconcont'>
                  <i className='icon icon-budget-listmenu'></i>
                </span>
              </div>
            )}
          {item.type === 'text'
            ? this._renderTextActivity()
            : item.type === 'time-activity'
            ? this._renderTimeActivity()
            : item.type === 'expense-activity'
            ? this._renderExpenseActivity()
            : null}
          {!this.data.showExpand && bHasSubCont && (
            <span
              className='itemaccordion'
              onClick={e => this._onToggleExpand(e, item.type)}
            >
              <i className='icon icon-grid-expand normal'></i>
            </span>
          )}
          {this.data.showExpand && (
            <span
              className='itemaccordion'
              onClick={e => this._onToggleExpand(e, item.type)}
            >
              <i className='icon icon-planner-accordionclose'></i>
            </span>
          )}
          {bHasSubCont && (
            <div className='itemsubcont'>
              <div className='desccont'>
                <div className='dropcol coltitle typo typo_viewsummary'>
                  {item.editable === 'description' ? (
                    <div className='label'>
                      <WysiwygEditor
                        placeholder='project.viewBudget.enterDescription'
                        value={item.description}
                        onBlur={this._onBlurActivityInput.bind(
                          this,
                          'description'
                        )}
                        onChange={this._onChangeActivityDesc.bind(
                          this,
                          'description'
                        )}
                        onKeyDown={this._onKeyPressSummary.bind(
                          this,
                          'description'
                        )}
                        autoFocus={true}
                      />
                    </div>
                  ) : (
                    <div
                      className='label'
                      onClick={this._onEditActivity.bind(this, 'description')}
                    >
                      <div
                        dangerouslySetInnerHTML={{
                          __html:
                            item.description ||
                            IntlUtil.convertMessage(
                              'project.viewBudget.addDescription'
                            )
                        }}
                      ></div>
                    </div>
                  )}
                </div>
              </div>
              <div className='infocont'>
                <div className='dropcol coltitle'>
                  {showLabelType && (
                    <div
                      className='label infocol'
                      onClick={this._onEditActivity.bind(this, 'labelType')}
                    >
                      <div className='info infoservice'>
                        <IntlMessage ident='project.viewBudget.labelInitialLabelType' />
                      </div>
                      &nbsp;
                      <div className='value infoservice'>
                        <FormVatTypeSelect
                          name='labelType'
                          value={item.labelType}
                          disabled={this.props.disabledEdit}
                          isQuickbookConnected={this.props.isQuickbookConnected}
                          quickbookItems={this.props.quickbookItems}
                          onChange={this._onChangeActivityLabelType.bind(
                            this,
                            'labelType'
                          )}
                          onBlur={this._onBlurActivityInput.bind(
                            this,
                            'labelType'
                          )}
                          onInputKeyDown={this._onKeyPressActivityVatInput.bind(
                            this,
                            'labelType'
                          )}
                          reloadQuickbookItems={this.props.reloadQuickbookItems}
                        />
                      </div>
                    </div>
                  )}
                  {item.editable === 'initialBudget' ? (
                    <div className='label infocol'>
                      <div className='info'>
                        <IntlMessage ident='project.viewBudget.labelInitialBudget' />
                      </div>
                      &nbsp;
                      <InputPrice
                        type='text'
                        name='sellingPrice'
                        maxLength={120}
                        label={currency.formatSymbol(0)}
                        required={true}
                        className='inlinesmall-input'
                        validations={['required']}
                        value={
                          item.initialBudget !== -1
                            ? item.initialBudget
                            : item.total
                        }
                        autoFocus={true}
                        onChange={this._onChangeActivityInput.bind(
                          this,
                          'initialBudget'
                        )}
                        onBlur={this._onBlurActivityInput.bind(
                          this,
                          'initialBudget'
                        )}
                        onKeyDown={this._onKeyPressActivityInput.bind(
                          this,
                          'initialBudget'
                        )}
                      />
                    </div>
                  ) : (
                    <div
                      className='label infocol'
                      onClick={
                        item.lockInitialBudget
                          ? null
                          : this._onEditActivity.bind(this, 'initialBudget')
                      }
                    >
                      <div className='info'>
                        <IntlMessage ident='project.viewBudget.labelInitialBudget' />
                      </div>
                      &nbsp;
                      <div className='value'>
                        <PriceText
                          value={
                            item.initialBudget !== -1
                              ? item.initialBudget
                              : item.total
                          }
                        />
                      </div>
                    </div>
                  )}
                  {item.type === 'expense-activity' &&
                    (item.editable === 'markupPercentage' ? (
                      <div className='label infocol'>
                        <div className='info'>
                          <IntlMessage ident='project.viewBudget.labelMarkUp' />
                        </div>
                        &nbsp;
                        <InputPrice
                          type='text'
                          name='markupPercentage'
                          maxLength={120}
                          label='0%'
                          required={true}
                          className='inlinesmall-input'
                          validations={['required']}
                          value={item.markupPercentage}
                          autoFocus={true}
                          onChange={this._onChangeMarkupPercentage}
                          onBlur={this._onBlurActivityInput.bind(
                            this,
                            'markupPercentage'
                          )}
                          onKeyDown={this._onKeyPressActivityInput.bind(
                            this,
                            'markupPercentage'
                          )}
                        />
                      </div>
                    ) : (
                      <div
                        className='label infocol'
                        onClick={this._onEditActivity.bind(
                          this,
                          'markupPercentage'
                        )}
                      >
                        <div className='info'>
                          <IntlMessage ident='project.viewBudget.labelMarkUp' />
                        </div>
                        &nbsp;
                        <div className='value'>
                          {item.markupPercentage ? item.markupPercentage : '0'}{' '}
                          %
                        </div>
                      </div>
                    ))}
                </div>
              </div>
              <div className='splitterwrap'>
                <div className='splitteritem col1'></div>
                <div className='splitteritem col2'></div>
              </div>
            </div>
          )}
          {item.type === 'expense-activity' && this.data.showExpand && (
            <div className='supplierwrap'>
              <ExpensePurchaseOrders
                item={item}
                purchaseOrders={item.purchaseOrders}
                onDeleteExpenseSupplier={this._onDeleteExpenseSupplier}
                onClickPoButton={this._onClickPoButton}
                poDownloadBaseUrl={this.props.poDownloadBaseUrl}
                onCreatePurchaseOrder={this._onCreatePurchaseOrder.bind(this)}
                onAddExpense={this._onAddExpense}
                onClickExpenseInvoiceTag={this._onClickExpenseInvoiceTag}
                hasDate={showDate}
              />
              <div className='supplierinfo'>
                <div className='suppliercont alt'>
                  <div className='title colitem'>
                    <div className='label'>
                      <FormAutoComplete
                        label='project.viewBudget.addSupplier'
                        name='supplier'
                        ref={this._references.inputAddSupplier}
                        validations={['required']}
                        value={this.state.newSupplierName}
                        displayValue={this.data.supplierKeyword}
                        options={this.data.supllierOptions}
                        onChange={this._onSearchExpenseSupplier.bind(
                          this,
                          item
                        )}
                        onSelect={this._onSelectExpenseSupplier.bind(
                          this,
                          item
                        )}
                        addLabel='project.form.addNewSupllier'
                        addValue={this.state.supplierContactName}
                        addName='supplierName'
                        onAddChange={this._onSearchExpenseSupplier.bind(
                          this,
                          item
                        )}
                        onToggleAdd={this._onSupplierAddToggle.bind(this, item)}
                        showAdd={bShowSupplierAdd ? true : false}
                        showSelection={
                          this.data.supllierOptions &&
                          this.data.supllierOptions.length > 0
                            ? true
                            : false
                        }
                        hasAutoSelect={false}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className='splitterwrap'>
                <div className='splitteritem colpo'></div>
              </div>
            </div>
          )}
          {!item.showAdd && this._isEditEnabled() && (
            <div className='addsplitter'>
              <div
                className='hovericon addaction'
                onClick={this._onShowAddAction.bind(this, item)}
              >
                <span className='iconcont'>
                  <i className='icon icon-common-itemadd'></i>
                </span>
              </div>
              <div className='line'></div>
            </div>
          )}
          {item.showAdd && this._renderActivityAction()}
        </div>
      )
    )
  }

  _onSupplierAddToggle (item, bAddShown) {
    if (this.props.onCreateContact && bAddShown) {
      this.props.onCreateContact(
        this.state.supplierContactName,
        (_contactErr, contactRes) => {
          if (contactRes && contactRes.id) {
            this._onAddExpenseSupplier(
              item,
              this.state.supplierContactName,
              contactRes.id
            )
          } else {
            if (this._references.inputAddSupplier.current) {
              this._references.inputAddSupplier.current.hideAdd()
            }
          }
        }
      )
    } else {
      this.setState({
        supplierContactName: '',
        bHideSupplierAdd: true,
        dataDate: new Date()
      })
    }
  }

  _onAddExpenseSupplier (item, keyword, contactId) {
    this.data.supplierKeyword = keyword

    let excludeIds = []
    if (item.purchaseOrders && item.purchaseOrders.length > 0) {
      excludeIds = item.purchaseOrders.map((obj, _idx) => obj.contactId)
    }

    if (this.props.onSearchSupplier) {
      if (this._searchTimeClient) window.clearTimeout(this._searchTimeClient)

      this._searchTimeClient = window.setTimeout(() => {
        this.props.onSearchSupplier(keyword, excludeIds, options => {
          if (options && options.length > 0) {
            const selOpj = _.find(
              options,
              (obj, _idx) => obj.contactId === contactId
            )
            if (selOpj) {
              this._onSelectExpenseSupplier(item, selOpj)
              this.setState({
                supplierContactName: '',
                bHideSupplierAdd: true
              })

              if (this._references.inputAddSupplier.current) {
                this._references.inputAddSupplier.current.hideAdd()
              }

              this.forceUpdate()
            }
          }
        })
      }, 700)
    }
  }

  _onAddExpense = (item, supplier) => {
    if (this.props.onAddExpense) {
      this.props.onAddExpense(item, supplier)
      trackAddExpense()
    }
  }

  _onChange () {
    if (this.props.onChange) {
      this.props.onChange(this.props.item)
    }
  }

  _onChangeActivityLabelType (name, object) {
    const value = object.value
    const item = this.props.item
    item[name] = value
    item.bSaveItem = true

    if (name === 'labelType' && this.props.onItemUpdate) {
      item.labelType = value
      this.props.onItemUpdate(item, name)
    }

    this._onChange()
  }

  _onClickExpenseInvoiceTag = (expense, supplier) => {
    if (this.props.onEditExpense) {
      this.props.onEditExpense(expense.id, supplier)
    }
  }

  _onClickPoAttchment (purchaseOrderId) {
    if (this.props.onPoAttachmentDownload) {
      this.props.onPoAttachmentDownload(purchaseOrderId)
    }
  }

  _onClickPoButton = purchaseOrderId => {
    if (this.props.onViewPurchaseOrder) {
      this.props.onViewPurchaseOrder(purchaseOrderId)
    }
  }

  _onDeleteExpenseSupplier = (contactId, supplierId, item) => {
    const suppliers = _.remove(
      item.purchaseOrders,
      orderObj => (orderObj.contactId === contactId && orderObj.supplierId === supplierId)
    )

    if (suppliers.length > 0 && this.props.onDeleteItemSupplier) {
      this.props.onDeleteItemSupplier(suppliers[0].supplierId)
    }

    this.forceUpdate()
  }

  _onSelectExpenseSupplier (item, supplierObj) {
    const itemSupplier = _.cloneDeep(supplierObj)

    if (item.purchaseOrders === undefined) {
      item.purchaseOrders = []
    }

    item.purchaseOrders.push(itemSupplier)
    this.data.supllierOptions = []
    this.data.supplierKeyword = ''

    if (this.props.onCreateItemSupplier) {
      this.props.onCreateItemSupplier(
        {
          contactId: itemSupplier.contactId,
          budgetItemId: item.id,
          purchaseOrderId: itemSupplier.purchaseOrderId
        },
        createRes => {
          itemSupplier.id = createRes.id
          itemSupplier.supplierId = createRes.id
        }
      )
    }

    this.forceUpdate()
  }

  _onSearchExpenseSupplier (item, keyword) {
    this.data.supplierKeyword = keyword

    let excludeIds = []
    if (item.purchaseOrders && item.purchaseOrders.length > 0) {
      // excludeIds = item.purchaseOrders.map((obj, _idx) => (obj.contactId));
      excludeIds = item.purchaseOrders.map(obj => obj)
    }

    if (this.props.onSearchSupplier) {
      if (this._searchTimeClient) window.clearTimeout(this._searchTimeClient)

      this._searchTimeClient = window.setTimeout(() => {
        this.props.onSearchSupplier(keyword, excludeIds, options => {
          options.forEach(opt => {
            ;(opt.value = opt.supplierName), (opt.label = opt.supplierName)
          })

          this.data.supllierOptions = options
          this.forceUpdate()
        })
      }, 250)
    }

    if (this.data.supllierOptions.length === 0) {
      this.setState({
        supplierContactName: this.data.supplierKeyword,
        bHideSupplierAdd: false
      })
    }
  }

  _renderActivityAction () {
    const bFilterExpense = this._isFilterByExpense()
    const bFilterTime = this._isFilterByTime()

    return (
      <div className='phaseactions'>
        <span
          className='phaseitem-close'
          onClick={this._onHideAddAction.bind(this)}
        >
          <i className='icon icon-phase-close'></i>
        </span>
        <div className='action'>
          {!bFilterExpense && (
            <Button
              className='button_phase activityact'
              title='project.viewBudget.timeActivity'
              onClick={this._onInsertItemInMiddle.bind(this, 'time-activity')}
            />
          )}
          {!bFilterTime && (
            <Button
              className='button_phase activityact'
              title='project.viewBudget.expense'
              onClick={this._onInsertItemInMiddle.bind(
                this,
                'expense-activity'
              )}
            />
          )}
          {!bFilterTime && !bFilterExpense && (
            <Button
              className='button_phase activityact'
              title='project.viewBudget.text'
              onClick={this._onInsertItemInMiddle.bind(this, 'text')}
            />
          )}
        </div>
      </div>
    )
  }

  _renderTextActivity () {
    const { item } = this.props
    return (
      <div className='itemcontent'>
        <div className='hovericon'>
          <span className='iconcont'>
            <i className='icon icon-budget-listmenu'></i>
          </span>
        </div>
        <span className='itemclose' onClick={this._onRemoveItem.bind(this)}>
          <i className='icon icon-phase-close'></i>
        </span>
        <div className='itemcol itemcoltitle itemcoltext'>
          {item.editable === 'title' ? (
            <div className='label'>
              <WysiwygEditor
                placeholder='project.viewBudget.enterDescription'
                value={item.title}
                onBlur={this._onBlurActivityText.bind(this)}
                onChange={this._onChangeActivityText.bind(this)}
                onKeyDown={this._onKeyPressSummary.bind(this, 'title')}
                autoFocus={true}
              />
            </div>
          ) : (
            <div
              className='label'
              onClick={this._onEditActivity.bind(this, 'title')}
            >
              <div dangerouslySetInnerHTML={{ __html: item.title }}></div>
            </div>
          )}
        </div>
      </div>
    )
  }

  _renderTimeActivity () {
    const {
      item,
      phaseStatus,
      showDate,
      phaseFromDate,
      phaseToDate,
      projectStartDate,
      projectEndDate
    } = this.props
    let activityKeyword = this.data.activityKeyword
    let options =
      item.editable === 'title' && !activityKeyword ? this.props.rateCards : []
    const bHidePriceEdit = item.bUseTotal ? true : false

    if (activityKeyword) {
      activityKeyword = activityKeyword.toLowerCase()
      for (const rateCardValue of this.props.rateCards) {
        const value = rateCardValue.value
          ? rateCardValue.value.toLowerCase()
          : ''
        if (value && value.includes(activityKeyword)) {
          options.push(rateCardValue)
        }
      }
    }
    // here we filter all rate-cards and assume that ones that are not having a type are `time-rate-cards`
    options = _.sortBy(options, 'value').filter(
      ({ type }) => !type || type === TIME_RATE_CARD
    )

    let dateHighlightStart = phaseFromDate
    let dateHighlightEnd = phaseToDate
    if (!dateHighlightStart || !dateHighlightEnd) {
      dateHighlightStart = projectStartDate
      dateHighlightEnd = projectEndDate
    }

    const spentClass = item.percentage > 100 ? 'label over' : 'label'

    return (
      <div className='itemcontent'>
        <div className='hovericon'>
          <span className='iconcont'>
            <i className='icon icon-budget-listmenu'></i>
          </span>
        </div>
        {!item.bUsed && (
          <span
            className='itemclose'
            onClick={this._onRemoveActivityTime.bind(this)}
          >
            <i className='icon icon-phase-close'></i>
          </span>
        )}
        {showDate &&
          (item.editable === 'date' ? (
            <div className='itemcol itemcoldate'>
              <div className='label'>
                <DateRangePicker
                  ref={this._references.daterange}
                  startDate={item.fromDate}
                  active={true}
                  endDate={item.toDate}
                  highlightedPeriods={[
                    { from: dateHighlightStart, to: dateHighlightEnd }
                  ]}
                  onKeyDown={this._onKeyPressActivityInput.bind(this, 'date')}
                  onSelect={this._onSelectActivityDate.bind(this)}
                  onClose={this._onCloseDate.bind(this, item)}
                />
              </div>
            </div>
          ) : (
            <div className='itemcol itemcoldate'>
              <div
                className='label'
                onClick={this._onEditActivity.bind(this, 'date')}
              >
                <span className='value'>
                  {this._renderFormatedDateRange(item.fromDate, item.toDate)}
                </span>
              </div>
            </div>
          ))}
        <div className='itemcol itemcoltitle'>
          <span className='iconcont'>
            <i className='icon icon-budget-time'></i>
          </span>
          {item.editable === 'title' ? (
            <div className='label'>
              <FormRateCardAutoComplete
                label='project.viewBudget.timeActivity'
                name='title'
                autoFocus={true}
                ref={this._references.inputTimeTitle}
                validations={['required']}
                value={item.title}
                displayValue={item.title}
                options={options}
                onChange={this._handleSearchActivity.bind(this)}
                onSelect={this._handleActivityTitleSelect.bind(this)}
                onBlur={this._handleActivityTitleBlur.bind(this)}
                onKeyDown={this._onKeyPressActivityTitleInput.bind(this)}
                hideAdd={true}
                showOptionIcon={true}
                showSelection={options && options.length > 0 ? true : false}
                hasAutoSelect={false}
              />
            </div>
          ) : (
            <div
              className='label'
              onClick={this._onEditActivity.bind(this, 'title')}
            >
              <span className='value'>{item.title}</span>
            </div>
          )}
        </div>
        {!bHidePriceEdit && (
          <div className='itemcol itemcolhour'>
            {item.editable === 'noHours' ? (
              <div className='label'>
                <InputNumber
                  type='text'
                  name='noHours'
                  maxLength={120}
                  label='project.viewBudget.selectedHours'
                  required={true}
                  className='inlinesmall-input'
                  validations={['required']}
                  value={item.noHours}
                  autoFocus={true}
                  onChange={this._onChangeActivityInput.bind(this, 'noHours')}
                  onBlur={this._onBlurActivityInput.bind(this, 'noHours')}
                  onKeyDown={this._onKeyPressActivityInput.bind(
                    this,
                    'noHours'
                  )}
                />
              </div>
            ) : (
              <div
                className='label'
                onClick={this._onEditActivity.bind(this, 'noHours')}
              >
                <span className='value'>
                  {item.noHours
                    ? currency.format(item.noHours)
                    : currency.format(0)}
                </span>
              </div>
            )}
          </div>
        )}
        {!bHidePriceEdit && (
          <div className='itemcol itemcolrate'>
            {item.editable === 'pricePerHour' ? (
              <div className='label'>
                <InputPrice
                  type='text'
                  name='pricePerHour'
                  maxLength={120}
                  label='project.viewBudget.pricePerHours'
                  required={true}
                  className='inlinesmall-input'
                  validations={['required']}
                  value={item.pricePerHour}
                  autoFocus={true}
                  onChange={this._onChangeActivityInput.bind(
                    this,
                    'pricePerHour'
                  )}
                  onBlur={this._onBlurActivityInput.bind(this, 'pricePerHour')}
                  onKeyDown={this._onKeyPressActivityInput.bind(
                    this,
                    'pricePerHour'
                  )}
                />
              </div>
            ) : (
              <div
                className='label'
                onClick={this._onEditActivity.bind(this, 'pricePerHour')}
              >
                <div className='value'>
                  <PriceText value={item.pricePerHour} />
                </div>
              </div>
            )}
          </div>
        )}
        {bHidePriceEdit && (
          <div className='itemcol itemcoltotalprice'>
            <div
              className='label'
              onClick={this._onClickTotalPrice.bind(this, item)}
            >
              <IntlMessage ident='project.viewBudget.totalPriceInfo' />
            </div>
          </div>
        )}
        <div className='itemcol itemcolbudget'>
          {item.editable === 'total' ? (
            <div className='label'>
              <InputPrice
                type='text'
                name='total'
                maxLength={120}
                label='project.viewBudget.priceDefault'
                required={true}
                className='inlinesmall-input'
                validations={['required']}
                value={item.total || ''}
                autoFocus={true}
                onChange={this._onChangeActivityInput.bind(this, 'total')}
                onBlur={this._onBlurActivityInput.bind(this, 'total')}
                onKeyDown={this._onKeyPressActivityInput.bind(this, 'total')}
              />
            </div>
          ) : (
            <div
              className='label'
              onClick={this._onEditActivity.bind(this, 'total')}
            >
              <div className='value'>
                <PriceText value={item.total} />
              </div>
            </div>
          )}
        </div>
        <div className='itemcol itemcolsellingprice'>
          <div className='label'>
            <div className='value'><PriceText value={item.total} /></div>
          </div>
        </div>
        <div className='itemcol itemcolspent'>
          {this._renderProgress(item.percentage, phaseStatus)}
          <div className={spentClass}>
            <div className='value'>
              <PriceText value={item.spentAmount} />
            </div>
          </div>
        </div>
        <div className='itemcol itemcolinvoiced'>
          <div className='label'>
            <div className='value'>
              <PriceText value={item.invoicedByActuals} />
            </div>
          </div>
        </div>
        <ConfirmDelete
          ref={this._references.confirmDelete}
          title='project.viewBudget.msgConfirmDelete'
          onClickOk={this._onRemoveItem.bind(this)}
        />
      </div>
    )
  }

  _renderExpenseActivity () {
    const { item, phaseStatus, showDate } = this.props
    const showCloseIcon =
      !item.bUsed && (item.expenseCount <= 0 || item.poCount <= 0)
        ? true
        : false
    const bHidePriceEdit = item.bUseTotal ? true : false
    const itmContClass = bHidePriceEdit
      ? 'itemcontent busetotal'
      : 'itemcontent'

    let activityKeyword = this.data.activityKeyword
    let options =
      item.editable === 'title' && !activityKeyword ? this.props.rateCards : []

    if (activityKeyword) {
      activityKeyword = activityKeyword.toLowerCase()
      for (const rateCardValue of this.props.rateCards) {
        const value = rateCardValue.value
          ? rateCardValue.value.toLowerCase()
          : ''
        if (value && value.includes(activityKeyword)) {
          options.push(rateCardValue)
        }
      }
    }

    options = _.sortBy(options, 'value').filter(
      ({ type }) => type === EXPENSE_RATE_CARD
    )
    const spentClass = item.percentage > 100 ? 'label over' : 'label'

    return (
      <div className={itmContClass}>
        <div className='hovericon'>
          <span className='iconcont'>
            <i className='icon icon-budget-listmenu'></i>
          </span>
        </div>
        {showCloseIcon && (
          <span
            className='itemclose'
            onClick={this._onRemoveItemExpense.bind(this)}
          >
            <i className='icon icon-phase-close'></i>
          </span>
        )}
        {showDate &&
          (item.editable === 'date' ? (
            <div className='itemcol itemcoldate'>
              <div className='label'>
                <DateRangePicker
                  ref={this._references.daterange}
                  startDate={item.fromDate}
                  active={true}
                  endDate={item.toDate}
                  onKeyDown={this._onKeyPressActivityInput.bind(this, 'date')}
                  onSelect={this._onSelectActivityDate.bind(this)}
                  onClose={this._onCloseDate.bind(this, item)}
                />
              </div>
            </div>
          ) : (
            <div className='itemcol itemcoldate'>
              <div
                className='label'
                onClick={this._onEditActivity.bind(this, 'date')}
              >
                <span className='value'>
                  {this._renderFormatedDateRange(item.fromDate, item.toDate)}
                </span>
              </div>
            </div>
          ))}
        <div className='itemcol itemcoltitle itemexpensetitle'>
          <span className='iconcont'>
            <CurrencyIcon
              currency={currency.symbol()}
              className={currency.getCurrency()}
            />
          </span>

          {item.editable === 'title' ? (
            <div className='label'>
              <FormRateCardAutoComplete
                label='project.viewBudget.newExpense'
                name='title'
                autoFocus={true}
                ref={this._references.inputTimeTitle}
                validations={['required']}
                value={item.title}
                displayValue={item.title}
                options={options}
                onChange={this._handleSearchActivity.bind(this)}
                onSelect={this._handleActivityTitleSelect.bind(this)}
                onBlur={this._handleActivityTitleBlur.bind(this)}
                onKeyDown={this._onKeyPressActivityTitleInput.bind(this)}
                hideAdd={true}
                showOptionIcon={true}
                showSelection={options && options.length > 0 ? true : false}
                hasAutoSelect={false}
              />
            </div>
          ) : (
            <div
              className='label'
              onClick={this._onEditActivity.bind(this, 'title')}
            >
              <span className='value'>{item.title}</span>
            </div>
          )}
        </div>
        {!bHidePriceEdit && (
          <div className='itemcol itemcolhour'>
            {item.editable === 'noHours' ? (
              <div className='label'>
                <InputNumber
                  type='text'
                  name='noHours'
                  maxLength={120}
                  label='project.viewBudget.selectedUnits'
                  required={true}
                  className='inlinesmall-input'
                  validations={['required']}
                  value={item.noHours}
                  autoFocus={true}
                  onChange={this._onChangeActivityInput.bind(this, 'noHours')}
                  onBlur={this._onBlurActivityInput.bind(this, 'noHours')}
                  onKeyDown={this._onKeyPressActivityInput.bind(
                    this,
                    'noHours'
                  )}
                />
              </div>
            ) : (
              <div
                className='label'
                onClick={this._onEditActivity.bind(this, 'noHours')}
              >
                <span className='value'>
                  {item.noHours
                    ? currency.format(item.noHours)
                    : currency.format(0)}
                  {' ' +
                    IntlUtil.convertMessage(
                      'project.viewBudget.unitForExpense'
                    )}
                </span>
              </div>
            )}
          </div>
        )}
        {!bHidePriceEdit && (
          <div className='itemcol itemcolrate'>
            {item.editable === 'pricePerHour' ? (
              <div className='label'>
                <InputPrice
                  type='text'
                  name='pricePerHour'
                  maxLength={120}
                  label='project.viewBudget.pricePerUnits'
                  required={true}
                  className='inlinesmall-input'
                  validations={['required']}
                  value={item.pricePerHour}
                  autoFocus={true}
                  onChange={this._onChangeActivityInput.bind(
                    this,
                    'pricePerHour'
                  )}
                  onBlur={this._onBlurActivityInput.bind(this, 'pricePerHour')}
                  onKeyDown={this._onKeyPressActivityInput.bind(
                    this,
                    'pricePerHour'
                  )}
                />
              </div>
            ) : (
              <div
                className='label'
                onClick={this._onEditActivity.bind(this, 'pricePerHour')}
              >
                <div className='value'>
                  <PriceText value={item.pricePerHour} />
                </div>
              </div>
            )}
          </div>
        )}
        {bHidePriceEdit && (
          <div className='itemcol itemcoltotalprice'>
            <div
              className='label'
              onClick={this._onClickTotalPrice.bind(this, item)}
            >
              <IntlMessage ident='project.viewBudget.totalExpensePriceInfo' />
            </div>
          </div>
        )}
        <div className='itemcol itemcolbudget'>
          {item.editable === 'total' ? (
            <div className='label'>
              <InputPrice
                type='text'
                name='total'
                maxLength={120}
                label='project.viewBudget.priceDefault'
                required={true}
                className='inlinesmall-input'
                validations={['required']}
                value={item.total || ''}
                autoFocus={true}
                onChange={this._onChangeActivityInput.bind(this, 'total')}
                onBlur={this._onBlurActivityInput.bind(this, 'total')}
                onKeyDown={this._onKeyPressActivityInput.bind(this, 'total')}
              />
            </div>
          ) : (
            <div
              className='label'
              onClick={this._onEditActivity.bind(this, 'total')}
            >
              <div className='value'>
                <PriceText value={item.total} />
              </div>
            </div>
          )}
        </div>
        <div className='itemcol itemcolsellingprice'>
          {item.editable === 'sellingPrice' ? (
            <div className='label'>
              <InputPrice
                type='text'
                name='sellingPrice'
                maxLength={120}
                label={currency.formatSymbol(0)}
                required={true}
                className='inlinesmall-input'
                validations={['required']}
                value={item.sellingPrice || ''}
                autoFocus={true}
                onChange={this._onChangeSellingPrice}
                onBlur={this._onBlurActivityInput.bind(this, 'sellingPrice')}
                onKeyDown={this._onKeyPressActivityInput.bind(
                  this,
                  'sellingPrice'
                )}
              />
            </div>
          ) : (
            <div
              className='label'
              onClick={this._onEditActivity.bind(this, 'sellingPrice')}
            >
              <div className='value'>
                <PriceText value={item.sellingPrice} />
              </div>
            </div>
          )}
        </div>
        <div className='itemcol itemcolspent'>
          {this._renderProgress(item.percentage, phaseStatus)}
          <div className={spentClass}>
            <div className='value'>
              <PriceText value={item.spentAmount} />
            </div>
          </div>
        </div>
        <div className='itemcol itemcolinvoiced'>
          <div className='label'>
            <div className='value'>
              <PriceText value={item.invoicedByActuals} />
            </div>
          </div>
        </div>

        <PopupBudgetPurchaseorder
          ref={this._references.refBudgetPurchaseOrder}
          container={this}
          target={this._references.triggerPurchaseOrder.current}
          onSearchSupplier={this.props.onSearchSupplier}
          onCreateItemSupplier={this.props.onCreateItemSupplier}
          onDeleteItemSupplier={this.props.onDeleteItemSupplier}
          onClickAdd={this._onCreatePurchaseOrder.bind(this)}
          onViewPurchaseOrder={this.props.onViewPurchaseOrder}
          onContactAdd={this.props.onCreateContact}
        />
        <ConfirmDelete
          ref={this._references.confirmDelete}
          title='project.viewBudget.msgConfirmDelete'
          onClickOk={this._onRemoveItem.bind(this)}
        />
      </div>
    )
  }

  _renderFormatedDateRange (fromDate, toDate) {
    // If item from date and to date set
    if (fromDate && toDate) {
      return this._renderDateRange(fromDate, toDate, true, true)

      // If item from date and to date are same
    } else if (fromDate && !toDate) {
      return this._renderDateRange(fromDate, null, true, false)

      // If phase from date and to date set
    } else if (this.props.phaseFromDate && this.props.phaseToDate) {
      return this._renderDateRange(
        this.props.phaseFromDate,
        this.props.phaseToDate,
        false,
        true
      )

      // If phase from date and to date are same
    } else if (this.props.phaseFromDate && !this.props.phaseToDate) {
      return this._renderDateRange(this.props.phaseFromDate, null, false, false)

      // If project from date is set and to date set
    } else if (this.props.projectStartDate && this.props.projectEndDate) {
      return this._renderDateRange(
        this.props.projectStartDate,
        this.props.projectEndDate,
        false,
        true
      )

      // If project from date is set and to date is empty
    } else if (this.props.projectStartDate && !this.props.projectEndDate) {
      return this._renderDateRange(
        this.props.projectStartDate,
        null,
        false,
        true
      )

      // If project from date is empty and to date is set
    } else if (!this.props.projectStartDate && this.props.projectEndDate) {
      return this._renderDateRange(null, this.props.projectEndDate, false, true)
    }

    return (
      <div className='date default'>
        <IntlMessage ident='project.viewBudget.addDateLabel' />
      </div>
    )
  }

  _renderDateRange (displayFromDate, displayToDate, bDateSet, bShowInfinity) {
    if (DateUtil.isDateEqual(displayFromDate, displayToDate)) {
      return (
        <div className={`date${bDateSet ? '' : ' default'}`}>
          {DateUtil.getDisplayDate(displayFromDate)}
        </div>
      )
    }

    return (
      <div className={`date${bDateSet ? '' : ' default'}`}>
        {displayFromDate ? (
          DateUtil.getDisplayDate(displayFromDate)
        ) : bShowInfinity ? (
          <span className='infinty'>&infin;</span>
        ) : (
          ''
        )}
        {displayToDate ? (
          ` - ${DateUtil.getDisplayDate(displayToDate)}`
        ) : bShowInfinity ? (
          <span>
            {' '}
            - <span className='infinty'>&infin;</span>
          </span>
        ) : (
          ''
        )}
      </div>
    )
  }

  /* Event handlers */
  _onToggleExpand (ev, type) {
    ev.preventDefault()

    if (type = 'expense-activity') {
      trackUnfoldExpenseActivity()
    }

    this.data.showExpand = !this.data.showExpand
    this.setState({ dataDate: new Date() })
  }

  _handleActivityInputChanged (name, bBlur, bEnter, ev) {
    const bEsc = ev.keyCode === 27
    const item = this.props.item

    if (!item.title) {
      return false
    }
    if (bBlur) {
      item.bTitleCompleted = item.title
      item.editable = false
    } else {
      if (this.props.isEstimate) {
        if (item.type === 'time-activity' || item.type === 'expense-activity') {
          let editable = false

          if (name === 'title') {
            item.bTitleCompleted = item.title ? true : false
          }

          if (!bEnter) {
            if (name === 'title') {
              editable = 'noHours'
              if (item.type === 'expense-activity') {
                editable = 'sellingPrice'
              }
            } else if (name === 'noHours') {
              editable = 'pricePerHour'
            } else if (name === 'pricePerHour' || name === 'sellingPrice') {
              editable = 'summary'
            } else if (name === 'summary') {
              editable = false
            }
          }

          item.editable = !item.bEdit || !bEsc ? editable : false
        }
      } else {
        if (item.type === 'time-activity') {
          let editable = false
          if (name === 'title') {
            item.bTitleCompleted = item.title
          }

          if (!bEnter) {
            if (name === 'title') {
              editable = !item.bUseTotal ? 'noHours' : 'total'
            } else if (name === 'noHours') {
              editable = !item.bUseTotal ? 'pricePerHour' : 'total'
            } else if (name === 'pricePerHour') {
              editable = 'total'
            } else if (name === 'total') {
              if (this.props.showDate) {
                editable = 'date'
              } else {
                editable = 'description'
                this.data.showExpand = true
              }
            } else if (name === 'date') {
              editable = 'description'
              this.data.showExpand = true
            } else if (name === 'description') {
              editable = 'initialBudget'
            } else if (name === 'initialBudget') {
              editable = false
            }
          }

          item.total = item.total != '' ? item.total : 0
          item.editable = !item.bEdit || !bEsc ? editable : false
        } else if (item.type === 'expense-activity') {
          let editable = false
          if (name === 'title') {
            item.bTitleCompleted = item.title
          }

          if (!bEnter) {
            if (name === 'title') {
              editable = !item.bUseTotal ? 'noHours' : 'total'
            } else if (name === 'noHours') {
              editable = !item.bUseTotal ? 'pricePerHour' : 'total'
            } else if (name === 'pricePerHour') {
              editable = 'total'
            } else if (name === 'total') {
              if (this.props.showDate) {
                editable = 'date'
              } else {
                editable = 'description'
                this.data.showExpand = true
              }
            } else if (name === 'date') {
              editable = 'description'
              this.data.showExpand = true
            } else if (name === 'description') {
              editable = 'initialBudget'
            } else if (name === 'initialBudget') {
              editable = 'sellingPrice'
            } else if (name === 'sellingPrice') {
              editable = 'markupPercentage'
            } else if (name === 'markupPercentage') {
              editable = false
            }
          }

          item.total = item.total != '' ? item.total : 0
          item.editable = !item.bEdit || !bEsc ? editable : false
        } else if (item.type === 'text') {
          if (name === 'title') {
            item.bTitleCompleted = item.title
          }

          item.editable = false
        }
      }
    }

    if (item.bTitleCompleted) {
      let updateFields = [name]

      if (name === 'noHours') {
        updateFields.push('total', 'bUseTotal', 'pricePerHour', 'sellingPrice')
      } else if (name === 'pricePerHour') {
        updateFields.push('total', 'bUseTotal', 'noHours', 'sellingPrice')
      } else if (name === 'total') {
        updateFields.push(
          'noHours',
          'pricePerHour',
          'sellingPrice',
          'bUseTotal'
        )
      } else if (name === 'sellingPrice') {
        updateFields.push('markupPercentage')
      } else if (name === 'markupPercentage') {
        updateFields.push('sellingPrice')
      }

      const bUpdateTotal = item.bUpdateTotal
      const bUpdateSpentAmount = item.bUpdateSpentAmount
      const bSaveItem = item.bSaveItem

      delete item.bUpdateTotal
      delete item.bUpdateSpentAmount
      delete item.bSaveItem

      if (bSaveItem) {
        if (!item.id && this.props.onItemCreate) {
          this.props.onItemCreate(item)
          this._onSave()
        } else if (!this.props.isEstimate && bUpdateSpentAmount) {
          this.props.calculateSpentAmount(item, () => {
            updateFields.push('spentAmount', 'percentage')
            this.props.onItemUpdate(item, updateFields)

            // Update project budget and phases
            if (bUpdateTotal) {
              this.props.onUpdateTotal()
            }
          })
        } else {
          this.props.onItemUpdate(item, updateFields)

          // Update project budget and phases
          if (bUpdateTotal) {
            this.props.onUpdateTotal()
          }
        }
      }
    }

    if (!item.editable && !bBlur) {
      if (bEnter) {
        if (this.props.onInsertItemInMiddle) {
          this.props.onInsertItemInMiddle(item.type, ev)
        }
      } else {
        this._updateActivity()
      }
    }

    this.setState({ dataDate: new Date() })
    return true
  }

  _onSelectActivityDate (fromDate, toDate) {
    const item = this.props.item
    item.fromDate = fromDate ? fromDate : null
    item.toDate = toDate ? toDate : null

    if (fromDate && toDate && fromDate.getTime() > toDate.getTime()) {
      item.fromDate = null
      item.toDate = null
    }

    this.props.onItemUpdate(item, ['fromDate', 'toDate'])
    item.editable = ''

    this.setState({ dataDate: new Date() })
  }

  _renderProgress (percentage, phaseStatus) {
    if (percentage <= 0) {
      return ''
    }

    let statClass = `progress ${phaseStatus ? phaseStatus.toLowerCase() : ''}`
    let displayValue = percentage
    if (displayValue > 100) {
      displayValue = displayValue < 200 ? displayValue - 100 : 100
    }

    if (percentage > 100) {
      statClass = statClass + ' over'
    }

    return (
      <div className={statClass}>
        <span className='stats-text'>{percentage}%</span>
      </div>
    )
  }
}

export default ProjectBudgetItem

/* eslint-enable */
